<template>
  <div class="box" style="width: 100%">
    <div class="banner" style="height: 900px">
<!--      <img src="../../static/img/banner1.jpg" alt="" />-->
      <el-carousel indicator-position="outside" style="height: 900px;">
        <el-carousel-item >
<!--                <img src="../../static/img/banner1.jpg" alt="" />-->
            <div  class="imgbo" style="background: url('../../static/img/banner1.jpg');height: 900px;  overflow: hidden;
    text-align: center;
    vertical-align: middle;
    background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;"></div>
        </el-carousel-item>
        <el-carousel-item >
          <div  class="imgbo" style="background: url('../../static/img/ee.jpg');height: 900px;
            overflow: hidden;
    text-align: center;
    vertical-align: middle;
    background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;"></div>
        </el-carousel-item>
        <el-carousel-item >

          <div  class="imgbo" style="background: url('../../static/img/cc.jpg');height: 900px;  overflow: hidden;
    text-align: center;
    vertical-align: middle;
    background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;"></div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="box1">
      <div class="titlebox">做梦想的超级乐园</div>
      <p class="title_fu">SUPER PARADISE</p>
      <img style="margin-bottom: 50px" src="../../static/img/biaoti.png" alt="">
      <div>
        <div class="box_banner1">
          <ul>
            <li>
              <img src="../../static/img/1.jpg" alt="" />
            </li>
            <li style="background: #e88866">一个解决问题的思维</li>
            <li>
              <img src="../../static/img/2.jpg" alt="" />
            </li>
            <li style="background: #df584d">一个平和淡定的性格</li>
            <li>
              <img src="../../static/img/3.jpg" alt="" />
            </li>
            <li style="background: #386091">一个受益终身的习惯</li>
          </ul>
          <ul>
            <li style="background: #f3c87b">一个自由和谐的空间</li>
            <li>
              <img src="../../static/img/4.jpg" alt="" />
            </li>
            <li style="background: #f1b67d">一个健康积极的心态</li>
            <li>
              <img src="../../static/img/5.jpg" alt="" />
            </li>
            <li style="background: #26b0c0">一个体魄康健的身体</li>
            <li>
              <img src="../../static/img/6.jpg" alt="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="box3" style="background: url('../../static/img/bg2.jpg');">
      <div class="box_banner2">
        <div class="titlebox" style="color: #ffffff; padding-top: 66px">
          一次奇妙的探索之旅 一个开心的魔力玩国
        </div>
        <p style="color: #ffffff; padding-top: 10px">WELCOME TO EXPLORE</p>
        <img  src="../../static/img/biaoti2.png" alt="">

        <div class="box_imgbanner">
          <div style="margin-right: 29px">
            <img class="imga"  src="../../static/img/img.png" alt="" />
          </div>
          <div>
            <p>我们不一样。</p>
            <p>我们更好玩。</p>
            <p>
              “Welcome to explore ”，欢迎来探索，这是开心玩国对大家的欢迎辞。
            </p>
            <p>
              进入开心玩国，是一次全新的乐园体验，当你沉浸其中，张开想象力的翅膀，奇妙的事情就发生了……
            </p>
            <p>可以穿越到“失落的Maya世界”，感受金字塔尖的繁盛与文明；</p>
            <p>可以回到1955，做一回真正的Disney在逃公主；</p>
            <p>可以在Cool车小镇，开上心爱的小车体验驾驶的乐趣；</p>
            <p>还可以在“问天X号”，漫步在星辰大海或是星球大战的世界；</p>
            <p>还可以来“未来实验室”，在妙趣横生中体会创造的奇妙； ……</p>
          </div>
        </div>
      </div>
    </div>
    <div class="box4" style="width: 100%;position:relative;height: 500px;margin: 0 auto;background: url('../../static/img/00.jpg'); overflow: hidden;
    text-align: center;
    vertical-align: middle;
    background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;">
      <div class="titlebox" style="padding-top: 65px">
        多业态的儿童乐园+ 更创意的主题场景
      </div>
      <p class="title_fu">BIG DREAM</p>
      <img style="margin-bottom: 50px" src="../../static/img/biaoti.png" alt="">
      <div style="display:flex;justify-content: center;text-align: center">
        <div style="position:relative;">
          <div class="box4title" >
            <div style="    position: absolute;color: #49326C;
    top: 58px;
    left: 180px;">一个会讲 <br>
              故事的儿童</div>
            <div style="position: absolute;color: #EA5C48;
    top: 58px;
    left: 430px;
    width: 133px;">一个体验<br>
              奇妙的主题</div>
            <div style="position: absolute; color:#26B0C0;
   top: 58px;
    left: 730px;
">一个快乐<br>
              成长的陪伴</div>
            <div style=" position: absolute;color: #E88866;
    top: 58px;
    left: 1000px;">一个创造<br>
              未来的乐园</div>
          </div>
        </div>
      </div>

    </div>
    <div style="width: 100%;background: url('../../static/img/bgan111.jpg');text-align: center;position: relative;overflow: hidden;
    text-align: center;
    vertical-align: middle;">
      <div class="box6" style="width: 1300px;margin:0 auto;">
        <div style="position:absolute;left: 45%">
          <div class="titlebox" style="color: #ffffff; padding-top: 66px">
            主题乐园
          </div>
          <p style="color: #ffffff;">Theme park</p>
          <img style="margin-top: 10px" src="../../static/img/biaoti2.png" alt="">

        </div>
        <div style="margin: 0 auto" class="boxzu">
          <div  v-for="item in datas" :key="item" @click="zhudetails(item.id)"  class="box6_div box11"  style="width: 214px;height: 600px;border-left: 0.5px solid rgb(225,225,225,0.3);border-right: 0.5px solid rgb(225,225,225,0.3);float:left;">
            <div style="margin-top: 400px">
              <p style="font-size: 24px;font-family: PingFang SC;font-weight: bold;color: #FFFFFF;line-height: 45px;">{{item.prd_name}}</p>
              <p style="font-size: 14px;font-family: PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 45px;">{{item.prd_desc}}</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="box5" style="margin-bottom: 40px;height: 550px;">
      <div class="titlebox" style="padding-top: 65px">十大项目</div>
      <p class="title_fu">project</p>
      <img style="margin-bottom: 50px;margin-top: 10px" src="../../static/img/biaoti.png" alt="">
      <div class="box5_banner">
        <div class="solution" style="float: left;margin-right: 8px" v-for="items in data" @click="details(items.id)">
          <div class="media-img margin-large-bottom">
            <div style="overflow: hidden; height: 142px;width: 252px;line-height: 185px;text-align: center;margin: auto;border-radius: 10px;">
              <img :src="items.prd_imgurl" alt="" class="img-responsive" style="width: 100%;height: 100%;display: block; border: 0;margin: auto;max-width: 100%;text-align: center;border-radius: 3px;"></div>
            <div class="mask" style="border-radius: 10px;" :style="{background:items.bg_color}">
              <div class="subtitle" style="text-align: center;margin-top: 0px;">
                <p style="font-size: 20px">{{items.pro_name}}</p>
                <p style="font-size: 12px;text-align: left;line-height: 20px;margin-top: 1px">{{items.prd_desc}}</p>
              </div>
            </div>
            <div class="linear-link" style="border-radius: 10px;" :style="{background:items.bg_color}">
              <div class="subtitle">
                <p class="text-white text-middle margin-small-bottom">{{items.prd_name}}</p>
                <p class="text-white"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box7" style="background: url('../../static/img/bg3.jpg')">
      <div class="titlebox" style="color: #ffffff; padding-top: 70px">
        乐园独角兽 赚钱新魔方
      </div>
      <p class="title_fu" style="color: #ffffff">To make money</p>
      <img style="margin-bottom: 50px;margin-top: 10px" src="../../static/img/biaoti2.png" alt="">

      <div class="box7_banner">
        <div>
          <img src="../../static/img/icon1.png" alt="" />
          <div style="font-size: 24px; color: #f2c410">品牌赋能</div>
          <p style="color: #f2c410">中国儿童游乐行业创始品牌</p>
        </div>
        <div>
          <img src="../../static/img/icon2.png" alt="" />
          <div style="color: #e67f22; font-size: 24px">产品赋能</div>
          <p style="color: #e67f22">儿童科学玩乐研究的高新技术企业</p>
        </div>
        <div>
          <img src="../../static/img/icon3.png" alt="" />
          <div style="font-size: 24px; color: #4dc0de">运营赋能</div>
          <p style="color: #4dc0de">全生态资源整合及承诺式服务的综合平台</p>
        </div>
      </div>
    </div>
    <div class="box8" style="background: #ffffff">
      <div class="titlebox" style="padding-top: 60px">
        创业孵化器 财富收割机
      </div>
      <p class="title_fu">一店多开 N种盈利渠道引爆中小本创业投资新格局</p>
      <img style="margin-bottom: 50px;margin-top: 10px" src="../../static/img/biaoti.png" alt="">

      <div class="box8_banner" style="position: relative">
        <div class="swiper-container" style="width: 1000px" ref="mySwiper">
          <div class="swiper-wrapper">
            <div class="solution swiper-slide" style="float: left;margin-right: 5px">
              <div class="media-img margin-large-bottom;width:313.33">
                <div style="overflow: hidden; width: 313.33px;line-height: 185px;text-align: center;margin: auto;border-radius: 3px;">
                  <img src="../../static/img/xin.png" alt="" class="img-responsive" style="width: 100%;height: 100%;display: block; border: 0;margin: auto;max-width: 100%;text-align: center;border-radius: 3px;"></div>
                <div class="mask" style="border-radius: 10px;background: #F3C87B;height: 88%;margin-top: 28px">
                  <div class="subtitle" style="text-align: center;margin-top: 18px;padding: 60px 33px;">
                    <p style="font-size: 16px;text-align: left;line-height: 35px">
                      泛产业大融合，创新模式整合，儿童游乐综合体的乐园+时代来临。不论是品牌还是规模，不论是人气还是经营，都将得到跨越式发展，引领产业新格局。
                    </p>
                  </div>
                </div>
                <div class="linear-link" style="border-radius: 10px;background: none;width: 100%;margin-bottom: 90px">
                  <div class="subtitle">
                    <p class="text-white text-middle margin-small-bottom" style="">创新模式引领新格局</p>
                    <p class="text-white"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="solution swiper-slide" style="float: left;margin-right: 5px">
              <div class="media-img margin-large-bottom;width:313.33">
                <div style="overflow: hidden; width: 313.33px;line-height: 185px;text-align: center;margin: auto;border-radius: 3px;">
                  <img src="../../static/img/big.png" alt="" class="img-responsive" style="width: 100%;height: 100%;display: block; border: 0;margin: auto;max-width: 100%;text-align: center;border-radius: 3px;"></div>
                <div class="mask" style="border-radius: 10px;background: #E88866;height: 88%;margin-top: 28px">
                  <div class="subtitle" style="text-align: center;margin-top: 18px;padding: 60px 33px;">
                    <p style="font-size: 16px;text-align: left;line-height: 35px">
                      3亿儿童构筑的游乐市场，是一座“储量”惊人的巨大“金矿”，蕴藏着无限商机，这种价值正在随着消费升级以及三胎放开的人口红利迅猛释放。
                    </p>
                  </div>
                </div>
                <div class="linear-link" style="border-radius: 10px;background: none;width: 100%;margin-bottom: 90px">
                  <div class="subtitle">
                    <p class="text-white text-middle margin-small-bottom" style=""> 市场巨大红利来袭</p>
                    <p class="text-white"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="solution swiper-slide" style="float: left;margin-right: 5px">
              <div class="media-img margin-large-bottom;width:313.33">
                <div style="overflow: hidden; width: 313.33px;line-height: 185px;text-align: center;margin: auto;border-radius: 3px;">
                  <img src="../../static/img/jiu.png" alt="" class="img-responsive" style="width: 100%;height: 100%;display: block; border: 0;margin: auto;max-width: 100%;text-align: center;border-radius: 3px;"></div>
                <div class="mask" style="border-radius: 10px;background: #D76056;height: 88%;margin-top: 28px">
                  <div class="subtitle" style="text-align: center;margin-top: 18px;padding: 60px 33px;">
                    <p style="font-size: 16px;text-align: left;line-height: 35px">
                      从产业生命周期角度看，儿童产业是朝阳产业，更是常青产业。儿童游乐可以说是非常典型的高频、刚需，这一特征决定了儿童产业，是持续投资、长期回报的产业。
                    </p>
                  </div>
                </div>
                <div class="linear-link" style="border-radius: 10px;background: none;width: 100%;margin-bottom: 90px">
                  <div class="subtitle">
                    <p class="text-white text-middle margin-small-bottom" style="">持久回报受益一生</p>
                    <p class="text-white"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="solution swiper-slide" style="float: left;margin-right: 5px">
              <div class="media-img margin-large-bottom;width:313.33">
                <div style="overflow: hidden; width: 313.33px;line-height: 185px;text-align: center;margin: auto;border-radius: 3px;">
                  <img src="../../static/img/win.png" alt="" class="img-responsive" style="width: 100%;height: 100%;display: block; border: 0;margin: auto;max-width: 100%;text-align: center;border-radius: 3px;"></div>
                <div class="mask" style="border-radius: 10px;background: #495F88;height: 88%;margin-top: 28px">
                  <div class="subtitle" style="text-align: center;margin-top: 18px;padding: 60px 33px;">
                    <p style="font-size: 16px;text-align: left;line-height: 35px">
                      六大主题空间，十大精选项目，对应的是N种盈利渠道，门票、会员卡、玩具、早教、体能培训、活动费、餐饮、百货……盈利空间何止是10倍20倍增长！
                    </p>
                  </div>
                </div>
                <div class="linear-link" style="border-radius: 10px;background: none;width: 100%;margin-bottom: 90px">
                  <div class="subtitle">
                    <p class="text-white text-middle margin-small-bottom" style=""> 盈利空间N倍拓展</p>
                    <p class="text-white"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="solution swiper-slide" style="float: left;margin-right: 5px">
              <div class="media-img margin-large-bottom;width:313.33">
                <div style="overflow: hidden; width: 313.33px;line-height: 185px;text-align: center;margin: auto;border-radius: 3px;">
                  <img src="../../static/img/all.png" alt="" class="img-responsive" style="width: 100%;height: 100%;display: block; border: 0;margin: auto;max-width: 100%;text-align: center;border-radius: 3px;"></div>
                <div class="mask" style="border-radius: 10px;background: #26B0C0;height: 88%;margin-top: 28px">
                  <div class="subtitle" style="text-align: center;margin-top: 18px;padding: 60px 33px;">
                    <p style="font-size: 16px;text-align: left;line-height: 35px">
                      从市调到选址，从开店到设计，从营销到管理，开心玩国儿童乐园+为所有合作伙伴，提供的一站式解决服务方案，从政策到落地执行，无微不至贯穿全程。！
                    </p>
                  </div>
                </div>
                <div class="linear-link" style="border-radius: 10px;background: none;width: 100%;margin-bottom: 90px">
                  <div class="subtitle">
                    <p class="text-white text-middle margin-small-bottom" style=""> 一站式服务解决方案</p>
                    <p class="text-white"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="solution swiper-slide" style="float: left;margin-right: 5px">
              <div class="media-img margin-large-bottom;width:313.33">
                <div style="overflow: hidden; width: 313.33px;line-height: 185px;text-align: center;margin: auto;border-radius: 3px;">
                  <img src="../../static/img/nuo.png" alt="" class="img-responsive" style="width: 100%;height: 100%;display: block; border: 0;margin: auto;max-width: 100%;text-align: center;border-radius: 3px;"></div>
                <div class="mask" style="border-radius: 10px;background: #443162;height: 88%;margin-top: 19px">
                  <div class="subtitle" style="text-align: center;margin-top: 18px;padding: 60px 33px;">
                    <p style="font-size: 16px;text-align: left;line-height: 35px">
                      所有合作店铺都有总部专业督导下店手把手指导运营，确保成功盈利。敢承诺重落地，真正敢说更敢做的儿童乐园连锁大品牌。真正无忧创业。
                    </p>
                  </div>
                </div>
                <div class="linear-link" style="border-radius: 10px;background: none;width: 100%;margin-bottom: 90px">
                  <div class="subtitle">
                    <p class="text-white text-middle margin-small-bottom" style=""> 承诺式连锁实践者</p>
                    <p class="text-white"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>

          <!-- Add Arrows -->

          <!-- <div style="background: url('../../static/img/qiang.png')">行业创始品牌</div>
          <div style="background: url('../../static/img/jing.png')">儿童玩乐研究中心</div>
          <div style="background: url('../../static/img/win.png')">大师级实战营销</div> -->

        </div>
        <div class="swiper-button-next" style="position: absolute;top: 200px;width:49px;height:49px;background: url('../../static/img/right.png')no-repeat">

        </div>
        <div class="swiper-button-prev"  style="position: absolute;top: 200px;width:49px;height:49px;background: url('../../static/img/left.png')no-repeat"></div>
<!--        <div style="margin-top: 30px"><img src="../../static/img/333.jpg" alt=""></div>-->
        <div style="margin-top:99px">
          <div>
            <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
            <div style="float:left;margin-left: 40px;margin-top: -25px; text-align: left;margin-right: 40px;">
              <p style="font-size: 18px;font-weight: 500;color: #333333;">创始</p>
              <div style="font-size: 60px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;">2005 <span style="font-size: 16px;">年</span></div>
            </div>
            <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
            <div style="float:left;margin-left: 68px;margin-top: -25px; text-align: left;margin-right: 68px;">
              <p style="font-size: 18px;font-weight: 500;color: #333333;">行业积累</p>
              <div style="font-size: 60px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;">20 <span style="font-size: 16px;">年</span></div>
            </div>
            <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
            <div style="float:left;margin-left: 50px;margin-top: -25px; text-align: left;margin-right: 50px;">
              <p style="font-size: 18px;font-weight: 500;color: #333333;">总部人才支持</p>
              <div style="font-size: 60px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;">500 <span style="font-size: 16px;">+</span></div>
            </div>
            <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
            <div style="float:left;margin-left: 40px;margin-top: -25px; text-align: left;margin-right: 40px;">
              <p style="font-size: 18px;font-weight: 500;color: #333333;">全国优秀门店</p>
              <div style="font-size: 60px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;">5000 <span style="font-size: 16px;">+</span></div>
            </div>
            <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
            <div style="float:left;margin-left: 80px;margin-top: -25px; text-align: left;margin-right: 40px;">
              <p style="font-size: 18px;font-weight: 500;color: #333333;">经验快速入行</p>
              <div style="font-size: 60px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;">0 <span style="font-size: 16px;"></span></div>
            </div>
            <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
          </div>
        </div>
      </div>
    </div>
    <div class="box8" style="background: #ffffff;padding-bottom: 40px">
      <div class="titlebox" style="">
        新闻资讯
      </div>
      <p class="title_fu">NEWS</p>
      <img style="margin-bottom: 0px;margin-top: 10px" src="../../static/img/biaoti.png" alt="">

      <div class="box8_banner" style="height: 800px">
        <div class="banner_new" style="padding-top: 40px">
          <ul>
            <li v-for="item in dataas" @click="detailsas(item.id)">
              <div class="new_imgs"><img :src="item.imgurl" alt=""></div>
              <div class="new-title">
                <!--                  <h3>{{item.title}}</h3>-->
                <span style="font-size: 24px;font-weight: bold;display: block">{{item.title}}</span>
                <p class="depict">{{item.depict}}</p>
                <p class="time" style="margin-top: 18px">{{item.create_time}}</p>
              </div>
            </li>
          </ul>
        </div>

      </div>
      <div>
        <div style="width: 300px;font-size: 16px;margin: 0 auto;cursor: pointer;
font-family: Microsoft YaHei;
font-weight: 400;
color: #FFFFFF;text-align: center;
line-height: 60px;
height: 60px;
background: rgb(234, 92, 72);" @click="newd()">更多新闻</div>

      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "Proindex",
  data() {
    return {
      data:[],
      url:'http://api.kxwg123.com/',
      total: 0,
      datas:[],
      dataas:[],
      listQuery: {
        page: 1,
        limit: 10,
      },
    };
  },
  mounted() {
    new Swiper ('.swiper-container', {
      slidesPerView: 3,
        spaceBetween: 30,
      loop: true,
      // 如果需要分页器
      // 如果需要前进后退按钮
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      // 如果需要滚动条
      // scrollbar: '.swiper-scrollbar',
      //如果需要自动切换海报
      // autoplay: {
      //   delay: 1000,//时间 毫秒
      //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
      // },
    })
  },
  created() {
    this.list()
    this.showPhotoS()
    this.showPhoto()
  },
  methods:{
    newd(){
      this.$nextTick(() => {
        this.$router.push('/newadd?page=1')
      });
    },
    detailsas(id){
      this.$router.push('/newdetails?id='+id+'&page='+this.listQuery.page)

    },
    showPhotoS(){
      let formdata = new FormData()
      formdata.append('page',this.listQuery.page)
      formdata.append('limit',this.listQuery.limit)

      this.$axios.post('/index/Article/ArticleList',formdata).then(res => {
        this.dataas = res.data.data.slice(0,3)
        this.listQuery.total = res.dataas.totalCount *2
        console.log(this.listQuery.total)
      });
    },
    zhudetails(id){
      this.$router.push('/zhudetails?id='+id)
    },
    details(id){
      this.$router.push('/prodetails?id='+id)

    },
    list(){
      let formdata = new FormData()
      formdata.append('catename','六大主题')
      formdata.append('page',1)
      formdata.append('limit',6)
      this.$axios.post('/index/Product/ProductList',formdata).then(res => {
        this.datas = res.data.data
        console.log(this.datas)
      });
    },
    showPhoto(){
      let formdata = new FormData()
      formdata.append('catename','十大项目')

      this.$axios.post('/index/Product/ProductList',formdata).then(res => {
        this.data = res.data.data
        console.log(this.data)

      });
    },
  }
};
</script>

<style scoped>
.depict{
  height:46px ;
  width: 900px;
  margin-top: 10px;
  font-size: 16px;

}
.banner_new li{
  width: 1300px;
  height: 160px;
  border-bottom: 1px dotted #C5C5C5;
  padding:  36px 0px ;
}
.new-title .time{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 30px;
  margin-top: 10px;
  display: block;
  width: 900px;
  height: 30px;

}
.new-title{
  text-align: left;
}
.banner_new li div{
  float: left;
}
.new-title span:hover{
  color: #D76056;
  cursor: pointer;
}
.new_imgs{
  width: 280px;
  height: 160px;
  border-radius: 10px;
  margin-right: 30px;
}
.new_imgs img{
  width: 280px;
  height: 160px;
  border-radius: 10px;
}
.new_imgs img{
  cursor: pointer;
  transition: all 0.6s;

}
.new_imgs img:hover{
  cursor: pointer;
  transform: scale(1.1);

}
.imga{
  cursor: pointer;
  transition: all 0.6s;
  margin-top: -20px;
}
.imga:hover{
  cursor: pointer;
  transform: scale(1.1);

}
.box_banner1 li{
  cursor: pointer;
  transition: all 0.6s;
  overflow: hidden;
  width: 215px;
  height: 150px;
}
.box_banner1 li:hover{
  cursor: pointer;
  transform: scale(1.1);

}
.box7_banner img{
  cursor: pointer;
  transition: all 0.6s;

}
.box7_banner img:hover{
  cursor: pointer;
  transform: scale(1.2);

}
.swiper-slide[data-v-e1d2e016] {
  background: none !important;
}
.swiper-container2 {
  width: auto; height: 300px;
}

.swiper-slide2 {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.linear-link{
  position: absolute;
  bottom: 0;
  width: 252px;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 500;
  color: #FFFFFF;
  height: 50px;
  background: #D68164;
  opacity: 0.9;
  border-radius: 10px !important;
  line-height: 50px;
}
.solution {
  margin-bottom: 10px;
}
.solution:hover{
  cursor: pointer;
}
.solution .media-img:hover .mask {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.box11:hover{
  background:rgba(244,205,136,0.6) ;
  cursor: pointer;
}
//#ea9475，#e2685e，#4c709c，#35b6c4，#7e66b1

.boxzu>:nth-child(1){
  background-color:yellow;
}
.boxzu :nth-child(1):hover{
  cursor: pointer;
}
.boxzu :nth-child(2):hover{
  cursor: pointer;

}
.boxzu :nth-child(3):hover{
  background:rgba(226,104,94,0.6) ;
  cursor: pointer;

}
.boxzu :nth-child(4):hover{
  background:rgba(76,112,155,0.6) ;
  cursor: pointer;

}
.boxzu :nth-child(5):hover{
  background:rgba(0,196,182,0.6) ;
  cursor: pointer;

}
.boxzu :nth-child(6):hover{
   background:rgba(59,110,102,0.6) ;
  cursor: pointer;

}


.solution .media-img:hover .mask {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.solution .media-img .mask {
  opacity: 0;
  z-index: 3;
  background: rgb(40 167 225 / 85%);
  width: 92%;
  height: 92%;
  position: absolute;
  right: 0;
  transition: 0.3s;
  margin-left: 11px;
  margin-top: 12px;
  bottom: 0;
  top: -7px;
  left: 1px;
}
.solution .media-img {
  position: relative;
  //width: 252px;
  //height: 300px;
}
.solution .media-img .mask .subtitle {
  padding: 17px;
  color: #ffffff;
  text-align: left;
}
.box4title{
  width: 1300px;
  height: 300px;
  position: relative;
  margin: 0 auto;
}
.box4title div{

  width: 91px;
  float: left;
  height: 100px;
  padding: 30px;
  font-size: 18px;
  line-height: 30px;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 24px;
  border-radius: 10px;
  font-family: PingFang;
  font-weight: 500;
  color: #ffffff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  /* -webkit-box-pack: center; */
  -ms-flex-pack: center;
  /* -webkit-justify-content: center; */
  justify-content: center;
  /* -webkit-box-align: center; */
  -ms-flex-align: center;
  /* -webkit-align-items: center; */
  align-items: center;
  background: red;
}
.box8 {
  text-align: center;
}
.box8 .box8_banner {
  width: 1300px;
  margin: 0 auto;
  height: 700px;
}
/* .box8_banner div {
  width: 300px;
  height: 106px;
  border-radius: 10px;
  float: left;
  margin-right: 65px;
  font-size: 24px;
  font-family: PingFang;
  font-weight: 500;
  color: #ffffff;
  line-height: 30px;
  padding-top: 290px;
} */
.box4 {
  height: 650px;
  text-align: center;
}
.box6 {
  height: 600px;
  //background: url("../../static/img/bg3.jpg");
}
.box7 {
  //background: url("../../static/img/bg3.jpg");
  height: 600px;
  text-align: center;
}
.box7 .titlebox {
  text-align: center;
}
.box7_banner {
  width: 1300px;
  height: 600px;
  margin: 0 auto;
  padding-top: 35px;
}
.box7_banner div {
  float: left;
  width: 432px;
  font-family: PingFang;
  font-weight: 500;
  color: #e67f22;
  line-height: 42px;
}
.box5 {
  height: 889px;
  text-align: center;
}
.box5_banner {
  width: 1300px;
  margin: 0 auto;
}
.box5_bannerimg {
  width: 252px;
  height: 142px;
  float: left;
  margin-right: 8px;
  margin-bottom: 8px;
  position: relative;
  cursor: pointer;

}
.box5_bannerimg div {
  width: 100%;
  height: 50px;
  background: #d68164;
  opacity: 0.9;
  border-radius: 10px;
  line-height: 50px;
  font-weight: 500;
  color: #ffffff;
  font-size: 20px;
  position: absolute;
  bottom: 0;
  cursor: pointer;
}
.box {
  margin: 0 auto;
  width: 1920px;
}
.box1 {
  width: 1300px;
  height: 530px;
  margin: 0 auto;
  text-align: center;
  padding: 53px 0px 0px 0px;
}
.box_banner1 ul li {
  width: 215px;
  height: 150px;
  float: left;
  line-height: 150px;
  color: #ffffff;
}
.titlebox {
  font-size: 36px;
  font-family: PingFang;
  font-weight: 500;
  color: #000000;
  margin-bottom: 20px;
}
.title_fu {
  font-size: 18px;
  font-family: PingFang;
  font-weight: 500;
  color: #666666;
  //margin-bottom: 50px;
}
.box3 {
  margin: 0 auto;
  width: 100%;
  height: 618px;
  //background: url("../../static/img/bg2.jpg");
}
.box_banner2 {
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div {
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 36px;
  text-align: left;
}
.box_imgbanner {
  margin-top: 26px;
}
.showin{
   width: 192px;
   height: 240px;
   float: left;
   margin-right: 8px;
   margin-bottom: 8px;
   position: relative;
   cursor: pointer;
   color: rgb(255, 255, 255);
   padding: 30px;
  border-radius: 6px;
 }
.banner .imgbo{
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  background-position-x: center;
  background-position-y: center;
  background-repeat: no-repeat;
}
.banner .el-carousel__container{
  height: 900px !important;
}
.imga:hover{
//box-shadow:0px 0px 2px 3px #000;
}
.box4title div:hover{
  font-weight: 800;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Proindex.vue